<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCardHeader class="p-1">
          <CRow>
            <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">

              <strong>ورود خروج کامندان</strong>

            </CCol>
            <CCol col="4" style="text-align: end">

              <CButton v-if="items.length>0" @click="send_data()" size="sm"
                       color="secondary"
                       class="mr-1">
                ذخیره تغییرات اطلاعات
              </CButton>
              <CButton v-if="items.length>0" @click="generateReport()" size="sm"
                       color="secondary"
                       class="mr-1">
                دریافت pdf
              </CButton>
            </CCol>
          </CRow>
        </CCardHeader>
      </CCol>
    </CRow>
    <CRow>
      <CCol col="8">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                <strong>انتخاب کامند</strong>
              </CCol>
            </CRow>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol>
                <CSelect
                    :options="personnel_list"
                    :value.sync="selected_personnel"
                    color="secondary">
                  کارمند
                </CSelect>

              </CCol>
              <CCol>
                <date-picker
                    type="month"
                    label="ماه"
                    v-model="month"/>

              </CCol>
              <CCol>
                <date-picker
                    type="year"
                    label="سال"
                    v-model="year"/>

              </CCol>
              <CCol>
                <CButton
                    color="dark"
                    @click="get_data_detail()"
                    size="sm"
                >
                  <CIcon name="cil-zoom"/>
                </CButton>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>

    </CRow>

    <CRow class="mb-5" id="data_container_report">

      <CCol col="12" v-if="items.length>0">
        <CCard v-for="item in items" :class="get_style(item)">
          <CCardHeader>
            <CRow>
              <CCol col="3">
                {{ item.date }}
              </CCol>
              <CCol col="3">
                <div v-if="!item.friday && !item.holiday">
                  غیر تعطیل
                </div>
                <label style="color: red" v-if="item.holiday">
                  تعطیل (رسمی)
                </label>
                <label style="color: red" v-if="item.friday">
                  تعطیل (جمعه)
                </label>
              </CCol>
              <CCol col="3">
                <CInputCheckbox
                    v-if="item.absent==1 && !item.friday && !item.holiday "
                    label="مرخصی"
                    :checked.sync="item.onleave"
                    value="1"/>
              </CCol>
              <CCol col="3">

                <label v-if="item.income_outgo.filter(x=>x.outgo=='').length>0" style="color: red">تردد ناقص</label>
                <CButton color="dark"
                         v-if="item.income_outgo.length==0"
                         @click="item.income_outgo.push({income:'',outgo:''})"
                         size="sm">
                  <CIcon name="cil-plus" size="sm"></CIcon>
                </CButton>
              </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <CRow>

              <CCol col="12">
                <CRow>
                  <CCol col="6" v-for="time in item.income_outgo">
                    <CRow>
                      <CCol col="6">
                        <date-picker type="time"
                                     v-model="time.income"
                                     :editable="true"
                                     format="HH:mm"
                        />
                      </CCol>
                      <CCol col="6">
                        <date-picker type="time"
                                     v-model="time.outgo"
                                     format="HH:mm"
                                     :editable="true"
                        />
                      </CCol>
                    </CRow>

                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter :class="get_style(item)">
            <CRow>
              <CCol>
                کل حضور:
                {{ secondsToString(calculate_present(item)) }}
              </CCol>
              <CCol>
                اضافه کاری:
                {{ secondsToString(calculate_extra_work(item)) }}
              </CCol>
              <CCol>
                کسر کار:
                {{ secondsToString(calculate_subtrac_work(item)) }}
              </CCol>
            </CRow>
          </CCardFooter>
        </CCard>

      </CCol>
      <CCol col="12">
        <CRow>
          <CCol>
            <div class="header-box">
              کارکرد
            </div>
            <p>کارکرد عادی:
              <label v-if="this.month<7">31</label>
              <label v-else>30</label>
            </p>
            <p>کل حضور:
              {{ secondsToString(calculate_all()[0]) }}
            </p>
          </CCol>
          <CCol>
            <div class="header-box">
              اضافه کاری
            </div>
            <p>
              نامجاز:
              {{ secondsToString(calculate_all()[1]) }}
            </p>
          </CCol>
          <CCol>
            <div class="header-box">
              مرخصی
            </div>
            <p>
              روزانه:{{ items.filter(x => x.onleave == true).length }}
            </p>
          </CCol>
          <CCol>
            <div class="header-box">
              کسر کار و غیبت
            </div>
            <p>
              کسر کار:
              {{ secondsToString(calculate_all()[2]) }}
            </p>
          </CCol>
          <CCol>
            <div class="header-box">
              ماموریت
            </div>
            <p>
              ساعتی:
              0
            </p>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <div>

      <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="true"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="report"
          :pdf-quality="2"
          margin="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          ref="html2Pdf"
      >
        <section slot="pdf-content">
          <!-- PDF Content Here -->
          <div id="pdf_container_report" class=" m-4">
            <CRow v-if="selected_personnel!=0">
              <CCol>{{ personnel_list.filter(x => x.value == selected_personnel)[0].label }}</CCol>
              <CCol>{{ month }} {{ year }}</CCol>
            </CRow>
            <table class="table table-bordered">
              <tr>
                <td>تاریخ</td>
                <td>وضعیت</td>
                <td>مدت حضور</td>

                <td>اضافه کاری</td>
                <td>کسر کار</td>
                <td>حضورغیاب</td>

              </tr>
              <tr v-for="item in items">
                <td>{{ item.date }}</td>
                <td>
                  <div v-if="!item.friday && !item.holiday">
                    غیر تعطیل
                  </div>
                  <label style="color: red" v-if="item.holiday">
                    تعطیل (رسمی)
                  </label>
                  <label style="color: red" v-if="item.friday">
                    تعطیل (جمعه)
                  </label>
                  <label style="color: red" v-if="item.onleave==true">
                    مرخصی
                  </label>
                  <label v-if="item.income_outgo.filter(x=>x.outgo=='').length>0" style="color: red"> تردد ناقص </label>

                </td>
                <td>{{ secondsToString(calculate_present(item)) }}</td>

                <td>{{ secondsToString(calculate_extra_work(item)) }}</td>
                <td>{{ secondsToString(calculate_subtrac_work(item)) }}</td>
                <td>
                  <CRow v-for="time in item.income_outgo">
                    <CCol col="6">
                      {{ time.income }}
                    </CCol>
                    <CCol col="6">
                      {{ time.outgo }}
                    </CCol>
                  </CRow>
                </td>

              </tr>

            </table>
            <CCol col="12">
              <CRow>
                <CCol>
                  <div class="header-box">
                    کارکرد
                  </div>
                  <p>کارکرد عادی:
                    <label v-if="this.month<7">31</label>
                    <label v-else>30</label>
                  </p>
                  <p>کل حضور:
                    {{ secondsToString(calculate_all()[0]) }}
                  </p>
                </CCol>
                <CCol>
                  <div class="header-box">
                    اضافه کاری
                  </div>
                  <p>
                    نامجاز:
                    {{ secondsToString(calculate_all()[1]) }}
                  </p>
                </CCol>
                <CCol>
                  <div class="header-box">
                    مرخصی
                  </div>
                  <p>
                    روزانه:{{ items.filter(x => x.onleave == true).length }}
                  </p>
                </CCol>
                <CCol>
                  <div class="header-box">
                    کسر کار و غیبت
                  </div>
                  <p>
                    کسر کار:
                    {{ secondsToString(calculate_all()[2]) }}
                  </p>
                </CCol>
                <CCol>
                  <div class="header-box">
                    ماموریت
                  </div>
                  <p>
                    ساعتی:
                    0
                  </p>
                </CCol>
              </CRow>
            </CCol>

          </div>
        </section>
      </vue-html2pdf>
    </div>

  </div>

</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import moment from 'moment-jalaali'

import Vue from "vue";
import VueHtml2pdf from 'vue-html2pdf'

export default {
  name: 'Login',
  components: {
    VueHtml2pdf

  },
  data() {
    return {
      selected_personnel: 0,
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      name: '',
      month: '',
      year: '',
      file: null,
      export_file_name: '',
      export_modal: false,
      json_data: [],
      items: [],
      fields: [
        {key: 'row', label: 'ردیف', _style: 'width:10%'},
        {key: 'name', label: "کارمند", _style: 'width:20%'},
        {key: 'id', label: "شماره شناسه", _style: 'width:20%;'},
        {key: 'date', label: "تاریخ", _style: 'width:20%;'},

      ],
      status_form: 0,
      selected_file_type: 0,
      personnel_list: [],
      settings: [],
    }
  }, mounted() {
    this.$root.root_validate_errors = [];
    this.month = moment().subtract(1, 'month').format('jMM')
    this.year = moment().format('jYYYY')
    this.get_personnel()
    this.get_settings()
  }, watch: {},
  methods: {
    get_style(item) {
      if (item.income_outgo.filter(x => x.outgo == '').length > 0) {
        return 'bg-yellow'

      } else {
        return ""
      }
    },
    calculate_all() {
      var self = this;
      var total_present = 0
      var total_extra = 0
      var total_subtrac = 0
      this.items.forEach(function (val) {
        total_present += self.calculate_present(val)
        total_extra += self.calculate_extra_work(val)
        total_subtrac += self.calculate_subtrac_work(val)
        // console.log("subtrac",total_subtrac,self.calculate_subtrac_work(val))
      })
      return [total_present, total_extra, total_subtrac];
    },
    calculate_present(item) {
      if (item.times.length == 0) {
        return 0;
      }

      var total = 0
      item.income_outgo.forEach(function (val, index) {
        if (val.outgo == '') {
          return 0;
        }
        var outgo = item.en_date + " " + val.outgo
        var income = item.en_date + " " + val.income
        total += new Date(outgo) - new Date(income);

      })
      return total / 1000;
    },
    calculate_extra_work(item) {
      if (item.times.length == 0) {
        return 0;
      }
      if (item.times.length % 2 == 1) {
        return 0;
      }
      var start_hour = item.en_date + " " + this.settings.filter(x => x.setting_key == "incoming_hour")[0].setting_value + ":00"
      var end_hour = item.en_date + " " + this.settings.filter(x => x.setting_key == "outgoing_hour")[0].setting_value + ":00"
      var total_extra = 0;
      var total_work = new Date(end_hour) - new Date(start_hour);
      item.income_outgo.forEach(function (val, index) {
        if (val.outgo == '') {
          return 0;
        }
        var outgo = item.en_date + " " + val.outgo
        var income = item.en_date + " " + val.income
        if (item.friday == true) {
          total_extra += new Date(outgo) - new Date(income)
        } else {
          if (new Date(end_hour) < new Date(outgo) && new Date(end_hour) > new Date(income)) {
            total_extra += new Date(outgo) - new Date(end_hour)
          }
          if (new Date(end_hour) < new Date(outgo) && new Date(end_hour) < new Date(income)) {
            total_extra += new Date(outgo) - new Date(income)
          }
        }

        // total += new Date(outgo) - new Date(income);

      })
// var working_time = this.calculate_present(item) - (total_work/1000)
      return total_extra / 1000;
    },
    calculate_subtrac_work(item) {
      var start_hour = item.en_date + " " + this.settings.filter(x => x.setting_key == "incoming_hour")[0].setting_value + ":00"
      var end_hour = item.en_date + " " + this.settings.filter(x => x.setting_key == "outgoing_hour")[0].setting_value + ":00"

      var daily_work = new Date(end_hour) - new Date(start_hour);

      daily_work = daily_work / 1000;

      if (item.times.length == 0) {

        if (item.friday == 0 && item.holiday == 0 && item.onleave == false) {
          return daily_work
        } else {
          return 0;

        }
      }

      var total = 0
      var val = item.income_outgo[0]
      if (val.outgo == '') {
        return 0;
      }
      var working = this.calculate_present(item);
      var extra = this.calculate_extra_work(item);
      //  daily_work =   new Date(end_hour) - new Date(start_hour);
      //
      // daily_work = daily_work/1000;
var wworking = parseInt(daily_work) - (parseInt(working) - parseInt(extra))
      if (wworking < 0) {
        return 0;
      }
      return wworking;
      var income = item.en_date + " " + val.income
      var outgo = item.en_date + " " + val.outgo
      total += new Date(income) - new Date(start_hour);
      // if(new Date(income) - new Date(start_hour))
      if (total < 0) {
        return 0;
      }

      return total / 1000;
    },
    secondsToString(seconds) {
      if (seconds < 0) {
        return "00:00"
      }
      var numhours = Math.floor(((seconds)) / 3600);
      var numminutes = Math.floor(((seconds) % 3600) / 60);
      if (numhours < 10) {
        numhours = '0' + numhours
      }
      if (numminutes < 10) {
        numminutes = '0' + numminutes
      }
      return numhours + ":" + numminutes

    },
    get_settings() {
      var self = this;
      console.log("route id " + this.$route.params.cat_id);

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('/get_settings', formData, {}).then(function (response) {

        var content_data = response.data;
        self.settings = response.data;

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_personnel() {
      var self = this;
      console.log("route id " + this.$route.params.cat_id);

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('/get_personnels', formData, {}).then(function (response) {

        var content_data = response.data;
        self.personnel_list = [{label: 'انتخاب کارمند', value: 0}]
        // items = content_cats.orders;
        content_data.forEach(function (val) {
          self.personnel_list.push({label: val.first_name + " " + val.last_name, value: val.id})

        })


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    send_data() {
      var self = this;
      const formData = new FormData();
      var url = "update_present_dates";
      var its = [];
      var validate = true;
      self.items.forEach(function (val) {
        val.income_outgo.forEach(function (date) {
          if (date.income == '' || date.outgo == '') {
            self.$root.modal_component.show_danger_modal("خطا", "تردد های ناقص را برطرف کنید");
            validate = false;
            return false;
          }
          its.push({
            'date': val.en_date + " " + date.income + ":00",
            'en_date': val.en_date + " " + date.income + ":00",
            'user_id': val.user_id,
          })
          its.push({
            'date': val.en_date + " " + date.outgo + ":00",
            'en_date': val.en_date + " " + date.outgo + ":00",
            'user_id': val.user_id
          })

        })
        if (val.onleave == true) {
          its.push({
            onleave: 1,
            'en_date': val.en_date,
            'user_id': val.user_id

          })
        } else {
          its.push({
            onleave: 0,
            'en_date': val.en_date,
            'user_id': val.user_id

          })
        }

      })
      if (validate == false) {
        return false;
      }
      // console.log("items",its);
      formData.append("items", JSON.stringify(its));
      axios.post(url, formData, {}).then(function (response) {

        // var content_data = response.data;
        self.$root.modal_component.show_api_response_modals(response);
        self.items = [];
        self.get_data_detail();
        // if (content_data.statusCode == 0) {
        //
        //
        // } else {
        //   self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
        //
        // }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_data_detail() {

      let self = this;
      const formData = new FormData();
      let url = "get_present_detail";

      formData.append('user_id', this.selected_personnel);
      formData.append('year', this.year);
      formData.append('month', this.month);

      axios.post(url, formData, {}).then((res) => {
        var start_time = ''
        var end_time = ''
        res.data.report.forEach(function (val) {
          val.income_outgo = []
          val.times.forEach(function (date, index) {
            const my_date = new Date(date.date);
            // date.time = my_date.getHours() + ":" + my_date.getMinutes()
            var min = my_date.getMinutes();
            var hour = my_date.getHours()
            if (min < 10) {
              min = '0' + min
            }
            if (hour < 10) {
              hour = '0' + hour
            }
            if (index % 2 == 0) {

              start_time = hour + ":" + min
            } else {
              end_time = hour + ":" + min
              val.income_outgo.push({
                income: start_time,
                outgo: end_time,

              })
              start_time = ''
              end_time = ''
            }
            // const my_date = new Date(date.date);
            // date.time = my_date.getHours() + ":" + my_date.getMinutes()
          })
          if (start_time != '') {
            val.income_outgo.push({
              income: start_time,
              outgo: end_time,
            })
            start_time = ''
            end_time = ''
          }
        })
        self.items = res.data.report

      })

          // axios.post(  '/admin/category', {
          //     name: self.name,
          //     description: self.description,
          //     image: self.image,
          //     cat: 0,
          // }).then(function (response) {
          //     self.name = '';
          //     self.description = '';
          //     // localStorage.setItem("api_token", response.data.access_token);
          //     // self.$router.push({ path: 'notes' });
          // })
          .catch(function (error) {
            console.log(error);
          });

    },
    generateReport() {
      // document.getElementById("pdf_container_report").innerHTML = document.getElementById("data_container_report").innerHTML
      this.$refs.html2Pdf.generatePdf()

    },
  }
}

</script>
<style>
.bg-yellow {
  background: #ffee3f;
}
</style>
